import { useEffect, useState } from 'react';

const useMediaQuery = (query) => {

    const [matches, setMatches] = useState(false);

    useEffect(() => {
        const media = window.matchMedia(query);
        const listener = () => setMatches(media.matches);
        listener();
        window.addEventListener('resize', listener);

        return () => window.removeEventListener('resize', listener);
    }, [matches]);


    return matches;
};

export default useMediaQuery;